import React, { useEffect } from 'react';
import AnimatedSection from '../Common/AnimatedSection';
import IntroSection from '../Common/IntroSection';
import ServiceIntro from './ServiceIntro';
import ServiceCategoryOverview from './ServiceCategoryOverview';
import WhyChooseUs from './WhyChooseUs';
import FeaturedTreatments from './FeatuedTreatments';
import ServiceJourney from './ServiceJourney';
// import ServiceInformationSection from './ServiceInformationSection';
import TestimonialsSection from '../Common/TestimonialSection';
import PricingInsuranceSection from '../Common/PricingInsuranceSection';
import VisitUsSection from '../Common/VisitUsSection';
import BookVisitSection from '../Common/BookVisitSection';
// import DentalFAQ from './DentalFAQ';
// import CheckInComponent from './CheckInComponent';
import PromoSection from '../Common/PromoSection';
import PatientFeedback from './PatientFeedback';
// import ServiceAccordianSection from './ServiceAccordianSection';
// import { ServiceCategoryInfo } from '../../const/ServiceInfo';

function Services() {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <div className="service">
      <AnimatedSection id='intro' delay={200}>
        <IntroSection 
          title='YOUR SMILE, OUR EXPERTISE'
          about='All the care your smile needs-under one roof.' />
      </AnimatedSection>

      <AnimatedSection id='patientFeedback' delay={400}>
        <PatientFeedback />
      </AnimatedSection>

      <AnimatedSection id='serviceInformation' delay={400}>
        <ServiceIntro />
      </AnimatedSection>

      <AnimatedSection id='serviceCategoryOverview' delay={600}>
        <ServiceCategoryOverview />
      </AnimatedSection>

      <AnimatedSection id='whyChooseUs' delay={800}>
        <WhyChooseUs />
      </AnimatedSection>

      <AnimatedSection id='featuredTreatment' delay={1000}>
        <FeaturedTreatments />
      </AnimatedSection>

      <AnimatedSection id='serviceJourney' delay={1200}>
        <ServiceJourney />
      </AnimatedSection>

      <AnimatedSection id='promoSection' delay={1000}>
        <PromoSection />
      </AnimatedSection>

      <AnimatedSection id='testimonials' delay={1200}>
        <TestimonialsSection />
      </AnimatedSection>

      <AnimatedSection id='pricing' delay={1400}>
        <PricingInsuranceSection />
      </AnimatedSection>
      
      <AnimatedSection id='visitUs' delay={1600}>      
        <VisitUsSection />
      </AnimatedSection>

      {/* <AnimatedSection id='faqComponent' delay={800}>
        <DentalFAQ faqs={ServiceCategoryInfo[page].faqs} />
      </AnimatedSection> */}

      <AnimatedSection id='bookVisit' delay={1800}>
        <BookVisitSection />
      </AnimatedSection>
    </div>
  );
}

export default Services;